document.addEventListener('DOMContentLoaded', function () {
  window.addEventListener('scroll', function () {
    var xmmune = document.querySelector('.xmmune')
    var firstStickyMenu = document.getElementById('countrySelectContainer')
    var secondStickyMenu = document.querySelector('.HNav__wrapper')

    if (xmmune && firstStickyMenu && secondStickyMenu) {
      var firstMenuHeight = firstStickyMenu.offsetHeight
      var secondMenuHeight = secondStickyMenu.offsetHeight

      if (window.scrollY === 0) {
        xmmune.style.top = '-' + xmmune.offsetHeight + 'px'
      } else {
        xmmune.style.display = 'block'
        xmmune.style.top = firstMenuHeight + secondMenuHeight + 'px'
      }
    } else {
      console.error('Required elements not found.')
    }
  })
})